export default [
  {
    code: 'aa',
    name: 'Aguas Calientes',
  },
  {
    code: 'ab',
    name: 'Baja California Norte',
  },
  {
    code: 'ac',
    name: 'Baja California Sur',
  },
  {
    code: 'ad',
    name: 'Campeche',
  },
  {
    code: 'ae',
    name: 'Chihuahua',
  },
  {
    code: 'af',
    name: 'Chiapas',
  },
  {
    code: 'ag',
    name: 'Coahuila',
  },
  {
    code: 'ah',
    name: 'Colima',
  },
  {
    code: 'ai',
    name: 'DF',
  },
  {
    code: 'aj',
    name: 'Durango',
  },
  {
    code: 'ak',
    name: 'Estado de México',
  },
  {
    code: 'al',
    name: 'Guerrero',
  },
  {
    code: 'am',
    name: 'Guanajuato',
  },
  {
    code: 'an',
    name: 'Hidalgo',
  },
  {
    code: 'ao',
    name: 'Jalisco',
  },
  {
    code: 'ap',
    name: 'Michoacan',
  },
  {
    code: 'aq',
    name: 'Morelos',
  },
  {
    code: 'ar',
    name: 'Nayarit',
  },
  {
    code: 'as',
    name: 'Nuevo León',
  },
  {
    code: 'at',
    name: 'Oaxaca',
  },
  {
    code: 'au',
    name: 'Puebla',
  },
  {
    code: 'av',
    name: 'Queretaro',
  },
  {
    code: 'aw',
    name: 'Quintana Roo',
  },
  {
    code: 'ax',
    name: 'Sinaloa',
  },
  {
    code: 'ay',
    name: 'San Luis Potosí',
  },
  {
    code: 'az',
    name: 'Sonora',
  },
  {
    code: 'za',
    name: 'Tabasco',
  },
  {
    code: 'zb',
    name: 'Tamaulipas',
  },
  {
    code: 'zc',
    name: 'Tlaxcala',
  },
  {
    code: 'zd',
    name: 'Veracruz',
  },
  {
    code: 'ze',
    name: 'Yucatán',
  },
  {
    code: 'zf',
    name: 'Zacatecas',
  },
];
